import { useEffect, useState } from "react";
import { t } from "i18next";
import { MagicStar } from "iconsax-react";
import DBButton from "../../component/global/DBButton";
import DBFieldBlock from "../../component/global/DBFieldBlock";
import DBInput from "../../component/global/DBInput";
import DBModal from "../../component/global/DBModal";
import { SENDER_CHANNEL } from "./constants";
import { DEFAULT_SMS_FROM_NUMBER } from "./senderConfigUtils";

export default function SenderConfigAIModal({
    show,
    channel,
    onHide,
    onApply,
}) {
    const [answer, setAnswer] = useState("");
    const [error, setError] = useState("");

    useEffect(() => {
        if (show) {
            setAnswer("");
            setError("");
        }
    }, [show, channel]);

    const questionKey =
        channel === SENDER_CHANNEL.EMAIL
            ? "survey.sender.ai.q.email"
            : channel === SENDER_CHANNEL.SMS
              ? "survey.sender.ai.q.sms"
              : "survey.sender.ai.q.in_app";

    const placeholderKey =
        channel === SENDER_CHANNEL.EMAIL
            ? "survey.sender.ai.placeholder.email"
            : channel === SENDER_CHANNEL.SMS
              ? "survey.sender.ai.placeholder.sms"
              : "survey.sender.ai.placeholder.in_app";

    const handleApply = () => {
        const value = answer.trim();
        if (!value && channel !== SENDER_CHANNEL.IN_APP) {
            setError(t("survey.sender.ai.required"));
            return;
        }

        if (channel === SENDER_CHANNEL.EMAIL) {
            onApply?.({ fromEmail: value });
        } else if (channel === SENDER_CHANNEL.SMS) {
            onApply?.({ fromNumber: value });
        } else {
            onApply?.({ name: value });
        }
        onHide?.();
    };

    return (
        <DBModal
            permanent
            show={show}
            minWidth={520}
            onHide={onHide}
            className="survey-sender-ai-modal"
        >
            <DBModal.Header closeBtn={onHide} title={t("survey.sender.ai.title")}>
                <MagicStar size={22} color="#7c3aed" />
            </DBModal.Header>
            <DBModal.Content>
                <p className="survey-sender-ai-intro">
                    {t("survey.sender.ai.intro")}
                </p>
                {channel === SENDER_CHANNEL.IN_APP ? (
                    <p className="survey-sender-ai-note">
                        {t("survey.sender.ai.in_app.note")}
                    </p>
                ) : (
                    <DBFieldBlock title={t(questionKey)} required error={error}>
                        <DBInput
                            size="large"
                            status={error && "error"}
                            value={answer}
                            placeholder={t(placeholderKey)}
                            onChange={(event) => {
                                setAnswer(event.target.value);
                                setError("");
                            }}
                        />
                    </DBFieldBlock>
                )}
                {channel === SENDER_CHANNEL.SMS && (
                    <p className="survey-sender-ai-hint">
                        {t("survey.sender.ai.sms.hint", {
                            default: DEFAULT_SMS_FROM_NUMBER,
                        })}
                    </p>
                )}
            </DBModal.Content>
            <DBModal.Footer>
                <DBButton
                    type="secondary"
                    outlined
                    caption={t("cancel")}
                    onClick={onHide}
                />
                <DBButton
                    caption={
                        <>
                            <MagicStar size={18} /> {t("survey.sender.ai.apply")}
                        </>
                    }
                    onClick={handleApply}
                />
            </DBModal.Footer>
        </DBModal>
    );
}
